module.exports = __webpack_public_path__ + "media/images/talent/mv-slider08-7c0d22135d1058c58f1c08d7c4e750b8.png";